import {
  BarChart3,
  Receipt,
  Users2,
  Truck,
  Coins,
  Boxes,
  FileText,
  TrendingUp,
  Building2,
  CircleDollarSign,
  Scale,
  Landmark,
  Banknote,
  BookOpen,
  ScrollText,
  MapPin,
  PackageOpen,
  ClipboardList,
  Clock,
  Percent,
  LayoutDashboard,
  AlertTriangle,
  Wallet,
  ArrowLeftRight,
  Undo2,
  ShoppingCart,
  CreditCard,
  Glasses,
} from "lucide-react";

/** Lumina report hub — G-POS group order */
export const REPORT_CATEGORIES = [
  "All",
  "Daily",
  "Sales",
  "Purchase",
  "Stock",
  "Ledger",
  "Party",
  "Outstanding",
  "Financial Year",
  "VAT",
  "Profit",
  "MIS",
  "Delivery",
  "Loyalty",
  "Stock Transfer",
  "Sales Return",
  "Purchase Return",
];

export const REPORT_CENTER_ITEMS = [
  // Daily
  { id: "daily-sales", label: "Daily Sales Summary", category: "Daily", icon: BarChart3, path: "/reports/daily-sales", ready: true },
  { id: "sales-day-book", label: "Sales Day Book", category: "Daily", icon: BookOpen, path: "/reports/sales-day-book", ready: true },
  { id: "sales-day-book-denom", label: "Sales Daybook with Denomination", category: "Daily", icon: Coins, path: "/reports/sales-day-book-denom", ready: true },
  { id: "x-report", label: "X-Report", category: "Daily", icon: ScrollText, path: "/reports/x-report", ready: true },
  { id: "z-report", label: "Z-Report", category: "Daily", icon: ScrollText, path: "/reports/z-report", ready: true },
  { id: "cash-collection", label: "Cash Collection", category: "Daily", icon: Coins, path: "/reports/cash-collection", ready: true },

  // Sales
  { id: "item-sales", label: "Item Wise Sales", category: "Sales", icon: Boxes, path: "/reports/item-sales", ready: true },
  { id: "cat-sales", label: "Category Wise Sales", category: "Sales", icon: TrendingUp, path: "/reports/category-sales", ready: true },
  { id: "dept-sales", label: "Department Wise Sales Summary", category: "Sales", icon: BarChart3, path: "/reports/dept-sales", ready: true },
  { id: "hourly-sales", label: "Hourly Invoice Wise Sales", category: "Sales", icon: Clock, path: "/reports/hourly-sales", ready: true },
  { id: "area-sales-summary", label: "Area Wise Sales Summary", category: "Sales", icon: MapPin, path: "/reports/area-sales-summary", ready: true },
  { id: "area-sales-invoice", label: "Area Wise Invoice Wise Sales", category: "Sales", icon: MapPin, path: "/reports/area-sales-invoice", ready: true },
  { id: "credit-sales", label: "Credit Sales Details", category: "Sales", icon: CreditCard, path: "/reports/credit-sales", ready: true },
  { id: "invoice-credit", label: "Invoice Wise Credit Details", category: "Sales", icon: FileText, path: "/reports/invoice-credit", ready: true },
  { id: "counter-sales", label: "Counter Sales", category: "Sales", icon: Receipt, path: "/reports/counter-sales", ready: true },
  { id: "account-sales", label: "Account Sales Details", category: "Sales", icon: Users2, path: "/reports/account-sales" },
  { id: "quotations", label: "Quotations", category: "Sales", icon: FileText, path: "/reports/quotations" },
  { id: "discounts", label: "Product Discounts", category: "Sales", icon: Percent, path: "/reports/discounts", ready: true },
  { id: "pos-round-bill", label: "POS Round Off (Bill Wise)", category: "Sales", icon: CircleDollarSign, path: "/reports/pos-round-bill", ready: true },
  { id: "pos-round-date", label: "POS Round Off (Date Wise)", category: "Sales", icon: CircleDollarSign, path: "/reports/pos-round-date", ready: true },
  { id: "pos-actions", label: "POS Actions Track", category: "Sales", icon: ClipboardList, path: "/reports/pos-actions", ready: true },
  { id: "rx-print-log", label: "Rx / Measurement Print Log", category: "Sales", icon: Glasses, path: "/reports/rx-print-log", ready: true },
  { id: "outdoor-salesman-profit", label: "Outdoor Salesman Invoice Profit", category: "Sales", icon: TrendingUp, path: "/reports/outdoor-salesman-profit", ready: true },

  // Purchase
  { id: "purchase-day-book", label: "Purchase Day Book", category: "Purchase", icon: BookOpen, path: "/reports/purchase-day-book", ready: true },
  { id: "product-purchase-history", label: "Productwise Purchase History", category: "Purchase", icon: Boxes, path: "/reports/product-purchase-history", ready: true },
  { id: "purchase-summary", label: "Daily / Monthly / Yearly Purchase", category: "Purchase", icon: BarChart3, path: "/reports/purchase-summary", ready: true },
  { id: "product-purchase-period", label: "Product Purchase Date/Month/Year", category: "Purchase", icon: Clock, path: "/reports/product-purchase-period", ready: true },
  { id: "product-purchase-details", label: "Product Wise Purchase Details", category: "Purchase", icon: Boxes, path: "/reports/product-purchase-details", ready: true },
  { id: "bill-purchase", label: "Bill Wise Purchase Details", category: "Purchase", icon: Receipt, path: "/reports/bill-purchase", ready: true },
  { id: "purchase-general", label: "Purchase with General Purchase", category: "Purchase", icon: ShoppingCart, path: "/reports/purchase-general", ready: true },
  { id: "area-purchase-summary", label: "Area Wise Purchase Summary", category: "Purchase", icon: MapPin, path: "/reports/area-purchase-summary", ready: true },
  { id: "area-purchase-invoice", label: "Area Wise Invoice Wise Purchase", category: "Purchase", icon: MapPin, path: "/reports/area-purchase-invoice", ready: true },
  { id: "debit-note-report", label: "Debit Note Report", category: "Purchase", icon: FileText, path: "/reports/debit-note-report", ready: true },
  { id: "purchase-volume", label: "Total Purchase Volume", category: "Purchase", icon: BarChart3, path: "/reports/purchase-volume", ready: true },
  { id: "purchase-and-return", label: "Purchase & Return", category: "Purchase", icon: Undo2, path: "/reports/purchase-and-return", ready: true },

  // Stock
  { id: "inventory", label: "Condensed Stock", category: "Stock", icon: Boxes, path: "/reports/condensed-stock", ready: true },
  { id: "condensed-physical", label: "Condensed Stock With Physical", category: "Stock", icon: ClipboardList, path: "/reports/condensed-physical", ready: true },
  { id: "opening-stock", label: "Opening Stock", category: "Stock", icon: PackageOpen, path: "/reports/opening-stock", ready: true },
  { id: "physical-stock", label: "Physical Stock", category: "Stock", icon: ClipboardList, path: "/reports/physical-stock", ready: true },
  { id: "stock-adjustment", label: "Stock Adjustment Details", category: "Stock", icon: ClipboardList, path: "/reports/stock-adjustment", ready: true },
  { id: "reorder-level", label: "Reorder Level", category: "Stock", icon: AlertTriangle, path: "/reports/reorder-level", ready: true },
  { id: "supplier-products", label: "Supplier Wise Product List", category: "Stock", icon: Building2, path: "/reports/supplier-products" },
  { id: "stock-register", label: "Stock Register / Group Stock", category: "Stock", icon: BookOpen, path: "/reports/stock-register" },
  { id: "batch-expiry", label: "Batch Expiry", category: "Stock", icon: Clock, path: "/reports/batch-expiry", ready: true },

  // Ledger
  { id: "ledger", label: "Ledger Report", category: "Ledger", icon: FileText, path: "/reports/ledger", ready: true },
  { id: "group-ledger", label: "Group Wise Ledger Summary", category: "Ledger", icon: FileText, path: "/reports/group-ledger", ready: true },
  { id: "cash-book", label: "Cash Book", category: "Ledger", icon: Banknote, path: "/reports/cash-book", ready: true },
  { id: "bank-book", label: "Bank Book", category: "Ledger", icon: Building2, path: "/reports/bank-book", ready: true },
  { id: "day-book", label: "Day Book", category: "Ledger", icon: BookOpen, path: "/reports/day-book", ready: true },
  { id: "cash-group", label: "Cash Group Summary", category: "Ledger", icon: Banknote, path: "/reports/cash-group", ready: true },
  { id: "bank-group", label: "Bank Group Summary", category: "Ledger", icon: Landmark, path: "/reports/bank-group", ready: true },

  // Party
  { id: "customer", label: "Customer Report", category: "Party", icon: Users2, path: "/reports/customer-sales", ready: true },
  { id: "customer-ledger", label: "Customer Ledger", category: "Party", icon: FileText, path: "/reports/customer-ledger", ready: true },
  { id: "supplier", label: "Supplier Summary", category: "Party", icon: Building2, path: "/reports/supplier-summary", ready: true },
  { id: "supplier-ledger", label: "Supplier Ledger", category: "Party", icon: FileText, path: "/reports/supplier-ledger", ready: true },
  { id: "account-customer", label: "Account Customer Details", category: "Party", icon: Users2, path: "/reports/account-customer" },
  { id: "company-details", label: "Company Details", category: "Party", icon: Building2, path: "/reports/company-details" },

  // Outstanding
  { id: "customer-age-wise", label: "Age Wise Receivables", category: "Outstanding", icon: Clock, path: "/reports/customer-age-wise", ready: true },
  { id: "bills-receivable", label: "Bills Receivable", category: "Outstanding", icon: Receipt, path: "/reports/bills-receivable", ready: true },
  { id: "receivable-last", label: "Receivable with Last Sales & Receipt", category: "Outstanding", icon: FileText, path: "/reports/receivable-last", ready: true },
  { id: "company-outstanding", label: "Company Wise Outstanding", category: "Outstanding", icon: Building2, path: "/reports/company-outstanding", ready: true },
  { id: "short-term-credit", label: "Short-Term Credit Details", category: "Outstanding", icon: CreditCard, path: "/reports/short-term-credit", ready: true },
  { id: "promised-receivable", label: "Promised Date Wise Receivable", category: "Outstanding", icon: Clock, path: "/reports/promised-receivable", ready: true },
  { id: "daily-collection", label: "Daily Customer Collection", category: "Outstanding", icon: Coins, path: "/reports/daily-collection" },
  { id: "supplier-age-wise", label: "Supplier Age Wise", category: "Outstanding", icon: Clock, path: "/reports/supplier-age-wise", ready: true },

  // Financial Year
  { id: "trial-balance", label: "Trial Balance", category: "Financial Year", icon: Scale, path: "/reports/trial-balance", ready: true },
  { id: "profit-loss", label: "Profit & Loss", category: "Financial Year", icon: TrendingUp, path: "/reports/profit-loss", ready: true },
  { id: "balance-sheet", label: "Balance Sheet", category: "Financial Year", icon: Landmark, path: "/reports/balance-sheet", ready: true },
  { id: "financial-statements", label: "Financial Statements", category: "Financial Year", icon: FileText, path: "/reports/financial-statements", ready: true },
  { id: "fund-flow", label: "Cash Flow / Fund Flow", category: "Financial Year", icon: Wallet, path: "/reports/fund-flow" },

  // VAT
  { id: "vat-computing", label: "VAT Computing", category: "VAT", icon: CircleDollarSign, path: "/reports/vat-computing", ready: true },
  { id: "input-vat", label: "INPUT VAT Ledger", category: "VAT", icon: FileText, path: "/reports/input-vat", ready: true },
  { id: "output-vat", label: "OUTPUT VAT Ledger", category: "VAT", icon: FileText, path: "/reports/output-vat", ready: true },
  { id: "tax", label: "Tax / VAT Summary + FTA CSV", category: "VAT", icon: CircleDollarSign, path: "/reports/tax", ready: true },

  // Profit
  { id: "profit-cat", label: "Profit Summary (Category)", category: "Profit", icon: TrendingUp, path: "/reports/profit-cat", ready: true },
  { id: "profit-subcat", label: "Profit Summary (Subcategory)", category: "Profit", icon: TrendingUp, path: "/reports/profit-subcat", ready: true },
  { id: "profit-dept", label: "Profit Summary (Department)", category: "Profit", icon: TrendingUp, path: "/reports/profit-dept", ready: true },
  { id: "profit-details", label: "Profit Details Datewise", category: "Profit", icon: BarChart3, path: "/reports/profit-details", ready: true },
  { id: "mis-profit", label: "Profit Summary", category: "Profit", icon: TrendingUp, path: "/reports/mis", ready: true },

  // MIS
  { id: "mis", label: "MIS Hub", category: "MIS", icon: LayoutDashboard, path: "/reports/mis", ready: true },
  { id: "mis-fast", label: "Fast Movers", category: "MIS", icon: TrendingUp, path: "/reports/top-items", ready: true },
  { id: "mis-below-cost", label: "Below Cost", category: "MIS", icon: AlertTriangle, path: "/reports/mis", ready: true },
  { id: "top-items", label: "Top Selling Items", category: "MIS", icon: TrendingUp, path: "/reports/top-items", ready: true },
  { id: "branch-comparison", label: "Branch Comparison", category: "MIS", icon: BarChart3, path: "/reports/branch-comparison", ready: true },
  { id: "online-orders", label: "Online Orders", category: "MIS", icon: ShoppingCart, path: "/reports/online-orders", ready: true },

  // Delivery
  { id: "delivery-person-detail", label: "Delivery Personwise Details", category: "Delivery", icon: Truck, path: "/reports/delivery-person-detail", ready: true },
  { id: "delivery-person", label: "Delivery Personwise Summary", category: "Delivery", icon: Truck, path: "/reports/delivery-person-sales", ready: true },
  { id: "delivery-customer", label: "Delivery Customer Details", category: "Delivery", icon: Users2, path: "/reports/delivery-customer", ready: true },
  { id: "delivery-area", label: "Delivery Area Sales", category: "Delivery", icon: MapPin, path: "/reports/delivery-area-sales", ready: true },

  // Loyalty
  { id: "privilege-reports", label: "Privilege / Loyalty Cards", category: "Loyalty", icon: CreditCard, path: "/reports/privilege-reports" },

  // Stock Transfer
  { id: "stock-transfer", label: "Stock Transfer", category: "Stock Transfer", icon: ArrowLeftRight, path: "/reports/stock-transfer", ready: true },

  // Sales Return
  { id: "sales-return-register", label: "Sales Return Register", category: "Sales Return", icon: Undo2, path: "/reports/sales-return-register" },
  { id: "sales-return-dept", label: "Sales Returns Deptwise", category: "Sales Return", icon: Undo2, path: "/reports/sales-return-dept" },

  // Purchase Return
  { id: "purchase-return-register", label: "Purchase Return Register", category: "Purchase Return", icon: Undo2, path: "/reports/purchase-return-register", ready: true },
  { id: "bill-purchase-return", label: "Bill Wise Purchase Return", category: "Purchase Return", icon: Receipt, path: "/reports/bill-purchase-return", ready: true },
];

export function reportTitleKey(id) {
  const camel = String(id).replace(/-([a-z])/g, (_, c) => c.toUpperCase());
  return `reports.${camel}`;
}

export function reportCategoryKey(category) {
  return `reports.cats.${category}`;
}

export function groupReportCenterItems(filter = "All") {
  const items = filter === "All" ? REPORT_CENTER_ITEMS : REPORT_CENTER_ITEMS.filter((r) => r.category === filter);
  const groups = [];
  for (const item of items) {
    const last = groups[groups.length - 1];
    if (!last || last.category !== item.category) {
      groups.push({ category: item.category, items: [item] });
    } else {
      last.items.push(item);
    }
  }
  return groups;
}

/** @returns {string | null} */
export function resolveActiveReportId(pathname) {
  if (pathname === "/reports" || pathname === "/reports/") {
    return null;
  }
  const exact = REPORT_CENTER_ITEMS.find((r) => pathname === r.path);
  if (exact) return exact.id;
  const item = REPORT_CENTER_ITEMS.find((r) => pathname.startsWith(`${r.path}/`));
  return item?.id ?? null;
}

export function findReportByPathOrId(pathname, reportId) {
  if (reportId) {
    return REPORT_CENTER_ITEMS.find((r) => r.id === reportId) ?? null;
  }
  return REPORT_CENTER_ITEMS.find((r) => r.path === pathname) ?? null;
}
